<template>
    <section class="sucesso">
        <div class="text-box">
            <h2>{{this.$root.mensagem}} com sucesso!!</h2>
            <p>Clique
                <router-link to="/" class="link">aqui</router-link>
                para ir para o início
            </p>
        </div>
    </section>
</template>

<script>
    export default {
        name: "sucesso",
        mounted() {
            setTimeout(() => {
                this.$router.push('/').catch(() => {})
            }, 7000)
        }
    }
</script>

<style lang="scss" scoped>
    .sucesso {
        height: 800px;
        color: #2b2b2b;
        position: relative;
    }

    .text-box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);

        h2 {
            font-size: 3rem;
            text-align: center;
        }

        p {
            margin: 20px auto 0 auto;
            text-align: center;
            font-size: 1.125rem;
        }
    }

    .link {
        color: #2b2b2b;
        text-decoration: underline;

        &:hover {
            color: #ccc;
        }
    }
</style>